<template>
  <div>
    <transition name="EnterFromAbove" appear mode="out-in">
      <main class="ph1 pv4 pa4-l">
        <form class="bg-component sign-in-modal center" @submit.prevent="auth">
          <fieldset id="sign_up" class="ph3 ph4-l ba b--transparent ph0 mh0">
            <legend class="tc f4 fw6 ph0 mh0">
              <div class="flex items-center w-100">
                <img src="@/assets/BC_logo_square_100x100.png" class="h3 v-mid ph3 pt3" alt="Block and Chain Games logo"/>
                <span class="v-mid fr f5 f4-l pt3">SIGN IN</span>
              </div>
            </legend>
            <div class="mt3 ph3 ph0-l">
              <input v-model="userName" class="pt3 input-reset ba white bg-transparent hover-gold w-100" type="text" autoFocus placeholder="Username" />
            </div>
            <div class="mv3 ph3 ph0-l">
              <input v-model="password" class="pt3 input-reset ba white bg-transparent hover-gold w-100" type="password" placeholder="Password" />
            </div>
          </fieldset>
          <div class="ph4 pb2">
            <small :class="classList">{{ errorMessage || authStatus }}</small>
          </div>
          <div class="ph4">
            <button class="w-100 pv2 ph3 input-reset ba br3 white cta-button grow pointer f5 dib" type="submit">
              <span>SIGN IN</span>
            </button>
            <a href="/register_basic" class="link tc w-100 pv2 ph3 ba br3 white cta-button-transparent grow pointer f5 dib mt3">Register Now</a>
          </div>
          <div class="w-100 bt ph2 pv3 mt4 flex items-center justify-center bg-white-10">
            <div class="pv0 ph3">
              <a href="/login_wallet" class="link white dim f7">Sign In With HALO Wallet</a>
            </div>
          </div>
        </form>
      </main>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'login_basic',
  data () {
    return {
      userName: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters({
      authStatus: 'auth/authStatus',
      errorMessage: 'errors/errorMessage'
    }),
    classList () {
      return { red: this.errorMessage }
    }
  },
  methods: {
    auth: function () {
      this.$store.commit('errors/AUTH_ERROR', '')
      const { userName, password } = this
      if (this.password === '') { // Check to see if password was entered
        this.$store.commit('errors/AUTH_ERROR', 'Please enter your password')
      } else if (this.username === '') { // Check to see if username was entered
        this.$store.commit('errors/AUTH_ERROR', 'Please enter your username')
      } else {
        this.$store.dispatch('auth/AUTH_BASIC', { userName, password })
          .then(() => {
            if (this.authStatus === 'success') {
              this.$store.commit('auth/AUTH_REQUEST', '')
              this.$router.push('/home')
            } else {
              console.error(this.errorMessage)
            }
          })
          .catch(error => {
            console.error(error)
            this.$router.push('/login_basic')
          })
      }
    }
  }
}

</script>
<style lang="scss" scoped>
</style>
